import { Tag, TagColorType } from "components/DesignSystem/Tag/Tag";
import { BadgeKind, StepStatus } from "./types";
import { LightTick } from "components/icons/LightTick";

type StepBadgeProps = {
  kind: BadgeKind;
  status: StepStatus;
};

const BADGE_LABEL: Record<BadgeKind, string> = {
  mandatory: "Mandatory",
  recommended: "Recommended",
  optional: "Optional",
};

const BADGE_COLOR: Record<BadgeKind, TagColorType> = {
  mandatory: "orange",
  recommended: "blue",
  optional: "gray",
};

export const StepBadge = ({ kind, status }: StepBadgeProps) => {
  if (status === "done") {
    return (
      <Tag tagType="green" icon={false} rounded>
        <span className="t-flex t-items-center t-gap-1">
          <span className="t-text-dark_green-70 t-flex">
            <LightTick />
          </span>
          <span>Done</span>
        </span>
      </Tag>
    );
  }

  return (
    <Tag tagType={BADGE_COLOR[kind]} icon={false} rounded>
      {BADGE_LABEL[kind]}
    </Tag>
  );
};
